import React from 'react'
import classNames from 'classnames'

import style from './style.module.scss'

type Props = {
  children: string
  className: string
}

function HeaderThree(props: Props) {
  const { children, className } = props
  return <h2 className={classNames(style.wrapper, className)}>{children}</h2>
}

export default HeaderThree
